import { call, put, select, takeLatest } from 'redux-saga/effects';

import forEach from 'lodash/forEach';

import { addCustomGTMEvent } from '../../../events';
import { formatError } from '../../../libs';
import antifraudAPI from '../../api/antifraud';
import checkoutAPI from '../../api/checkout';
import { Creators as AppCreators } from '../../reducers/app';
import { Creators, Types } from '../../reducers/checkout';
import { getUserDeviceInfo } from '../../utils/agent';
import { getCartId } from '../../utils/cookies';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

function* sendPayment() {
  try {
    const token = yield select(getToken);
    const {
      app,
      creditCard: { creditCards },
      checkout: { payment, financing, cart, location },
    } = yield select(getState);

    const siteId = app.getIn(['config', 'siteId']);

    const device = getUserDeviceInfo();
    const paymentOrder = {
      formaPagamento: { id: +payment.getIn(['id']) },
      infoAntifraude: {
        localizacao: location,
        dispositivo: `${device?.os?.name}${device?.browser?.name}`,
      },
    };

    const antifraud = yield call(antifraudAPI.getUsersIP);

    if (antifraud?.ip) {
      paymentOrder.infoAntifraude.ip = antifraud.ip;
    }

    if (payment.getIn(['id']) === 7) {
      paymentOrder.cartoes = [];

      forEach(creditCards, function cb(item) {
        const titular = /\s$/.test(item.titular) ? item.titular.substring(0, item.titular.length - 1) : item.titular;
        const cc = {
          parcela: item.installment.parcelas.find((p) => p.numeroParcelas.toString() === item.parcela.toString()),
          valor: item.valor,
          numero: (item.numero.match(/\d+/g) || []).join(''),
          titular,
          seguranca: (item.seguranca.match(/\d+/g) || []).join(''),
          validade: item.validade,
          sequencia: item.sequencia,
        };

        paymentOrder.cartoes.push(cc);
      });
    }

    if (payment.getIn(['id']) === 10) {
      paymentOrder.financeira = {
        carencia: financing.getIn(['carencia']),
        primeiroVencimento: financing.getIn(['primeiroVencimento']),
        parcelas: [financing.getIn(['parcelas'])],
      };
    }

    yield call(checkoutAPI.sendPaymentOrder, getCartId(), paymentOrder, token, siteId);

    // Dispara o evento success_add_payment_info
    const {
      products: { subtotal },
      sellers,
    } = cart;
    const seller = sellers?.[0];

    if (seller) {
      const dataLayer = {
        value: subtotal,
        coupon: cart?.coupon?.name,
        payment_type: payment.getIn(['descricao']),
        items: seller?.lines?.map((item, index) => ({
          item_id: item.product.id,
          item_name: item.product.name,
          quantity: item.quantity,
          price: item.product.price,
          affiliation: sellers?.[0].seller.name,
          // discount: item?.valorDesconto,
          index,
        })),
      };

      addCustomGTMEvent({
        event: 'success_add_payment_info',
        data: dataLayer,
        clear: true,
      });
    }

    yield put(
      Creators.sendPaymentSuccess({
        confirmPaymentOrder: { success: true },
      })
    );
  } catch (error) {
    addCustomGTMEvent({
      event: 'error_add_payment_info',
      data: {
        error: error?.message || '',
      },
    });
    yield put(AppCreators.feedbackRequest({ open: true, message: formatError(error).message, autoHideDuration: 7500 }));
    yield put(Creators.sendPaymentError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.SEND_PAYMENT_REQUEST, sendPayment);
}
